import React, { useState } from "react";
import {
  Table, Button, Space, Tag, message, Popconfirm,
  Form, Input, Drawer
} from 'antd'
import { PlusOutlined, MessageOutlined } from '@ant-design/icons';
import { useApiSelector } from 'src/hooks'
import { useRequest, dispatchAsync } from 'friday-async'

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const SmsTemplate = () => {
  const apis = useApiSelector();
  const { dataArray, isValidating, revalidate } = useRequest(apis.smsTemplate.list(), {
    paginated: false,
  })

  const [drawer, setDrawer] = useState<{ visible: boolean; info: any }>({
    visible: false, info: null
  })
  const [form] = Form.useForm()
  const isEdit = !!drawer.info

  // ====== CRUD ======
  const handleCreate = () => setDrawer({ visible: true, info: null })

  const handleEdit = (record: any) => {
    setDrawer({ visible: true, info: record })
  }

  const handleSubmit = async () => {
    try {
      const vals = await form.validateFields()
      let error: any
      if (isEdit) {
        const r = await dispatchAsync(apis.smsTemplate.update({ _id: drawer.info._id, ...vals }))
        error = r.error
      } else {
        const r = await dispatchAsync(apis.smsTemplate.create(vals))
        error = r.error
      }
      if (error) return message.error(isEdit ? '编辑失败' : '创建失败')
      message.success(isEdit ? '编辑成功' : '创建成功')
      setDrawer({ visible: false, info: null })
      form.resetFields()
      revalidate()
    } catch (err) { console.log(err) }
  }

  const handleRemove = async (_id: string) => {
    const { error } = await dispatchAsync(apis.smsTemplate.remove({ _id }))
    if (error) return message.error('删除失败')
    message.success('删除成功')
    revalidate()
  }

  // ====== 表格列 ======
  const columns = [
    {
      title: '短信模板ID',
      dataIndex: 'templateId',
      key: 'templateId',
      width: 250,
      render: (v: string) => <Tag color="blue">{v}</Tag>,
    },
    {
      title: '短信名称',
      dataIndex: 'name',
      key: 'name',
      width: 300,
    },
    { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: 200 },
    {
      title: '操作',
      key: 'action',
      width: 160,
      render: (_: any, record: any) => (
        <Space>
          <Button type="link" size="small" onClick={() => handleEdit(record)}>
            编辑
          </Button>
          <Popconfirm title="确定删除该短信模板？" onConfirm={() => handleRemove(record._id)}>
            <Button type="link" size="small" danger>删除</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ]

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Button type="primary" ghost icon={<PlusOutlined />} onClick={handleCreate}>
        新建短信模板
      </Button>
      <Table
        rowKey="_id"
        columns={columns}
        dataSource={dataArray}
        loading={isValidating}
        pagination={false}
      />

      {/* 新增/编辑 抽屉 */}
      <Drawer
        title={isEdit ? '编辑短信模板' : '新建短信模板'}
        width={520}
        open={drawer.visible}
        onClose={() => {
          setDrawer({ visible: false, info: null })
          form.resetFields()
        }}
        destroyOnClose
        footer={
          <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button style={{ width: 120 }} onClick={() => {
              setDrawer({ visible: false, info: null })
              form.resetFields()
            }}>取消</Button>
            <Button style={{ width: 120 }} type="primary" onClick={handleSubmit}>确认</Button>
          </Space>
        }
      >
        <Form {...layout} form={form}
          initialValues={isEdit ? drawer.info : {}}
        >
          <Form.Item name="templateId" label="短信模板ID" rules={[{ required: true, message: '请输入短信模板ID' }]}>
            <Input placeholder="如 SMS_123456789" />
          </Form.Item>
          <Form.Item name="name" label="短信名称" rules={[{ required: true, message: '请输入短信名称' }]}>
            <Input placeholder="如 预约成功通知" />
          </Form.Item>
        </Form>
      </Drawer>
    </Space>
  )
}

export default SmsTemplate
